import * as React from "react";
import Marketplace from "./components/Marketplace";

export default ({
  data,
}: React.ComponentProps<typeof Marketplace>): JSX.Element => {
  return <Marketplace data={data} />;
};
